import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'
import store from '@/store'

const hide = () => !store.getters['subscription/isB2bPurchased']

export default [
  {
    title: 'navigation.b2b-dashboard',
    route: 'admin:b2b',
    svgIcon: 'icon-crm',
    permission: [
      SUBUSER_PERMISSION_SLUGS.B2B_VIEW,
      SUBUSER_PERMISSION_SLUGS.B2B_MANAGE,
      SUBUSER_PERMISSION_SLUGS.B2B_DELETE,
    ],
    hide,
  },
]
